import { render, staticRenderFns } from "./Governates.vue?vue&type=template&id=3392e960&"
import script from "./Governates.vue?vue&type=script&lang=js&"
export * from "./Governates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports